module.exports = __webpack_public_path__ + "static/media/webvr-support-chromium.8739ef58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webvr-support-chromium.png
// module id = 1531
// module chunks = 0